// extracted by mini-css-extract-plugin
export default {"grid-alike-section":"BoxSection_grid-alike-section__Nzo8E","grid-header-right":"BoxSection_grid-header-right__Sxp9g"};